import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MobipaidPage } from './mobipaid.page';

const routes: Routes = [
  {
    path: '',
    component: MobipaidPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class MobipaidPageRoutingModule {}
